import { SquareXIcon } from 'lucide-react';

import { SplitButton, SplitButtonPrimary } from '@/components/ui/split-button';

// TODO: implement resolve conflicts flow
export function ConflictsIndicator() {
  return (
    <SplitButton variant="outline">
      <SplitButtonPrimary disabled>
        <SquareXIcon className="size-4 text-red-500" />
        Conflicts
      </SplitButtonPrimary>
    </SplitButton>
  );
}
